import { useContext, useEffect } from 'react';
import { CryptoContext } from '../context/CryptoContext'; // Path to your context
import { useParams } from 'react-router-dom';
import { AllTable } from './AllTable';
import { Outlet } from "react-router-dom";
import Filters from "../components/Filters";
import { CoinByCategoryTable } from './CoinByCategoryTable';


export const ByCategory = () => {
    const { getCoinByCategories, coinByCategory } = useContext(CryptoContext);
    const { category } = useParams();

    // Fetch coins by category whenever the category changes
    useEffect(() => {
        if (category) {
            getCoinByCategories(category);
        }
    }, [category]);

    if (coinByCategory) {
        console.log(coinByCategory[0])
    }


    return (
        <section className="w-[85%] h-full flex flex-col mt-16 mb-24 relative">
            <Filters />
            {/* <TableComponent /> */}
            {coinByCategory ? (
                <CoinByCategoryTable data={coinByCategory} />

            ) : <div className="w-full min-h-[50vh] flex justify-center items-center">
                <div
                    className="w-8 h-8 border-4 border-solid border-green rounded-full border-b-gray-200 animate-spin"
                    role="status"
                />
                <span className="text-base ml-2">please wait...</span>
            </div>
            }
            <Outlet />
        </section>
    );
};


